import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

type DeletePublishedConnectionDraftRequestParams = {
  readonly luid: string;
}
export class DeletePublishedConnectionDraftRequest extends Request<DeletePublishedConnectionDraftRequestParams, IResult> {
  constructor(params: DeletePublishedConnectionDraftRequestParams) {
    super('deletePublishedConnectionDraft', params);
  }
}
